
<dx-pie-chart
  id="pie"
  type="doughnut"
  title=""
  palette="Soft Pastel"
  [dataSource]="datiGrafici"
>
  <dxi-series argumentField="descrizione" valueFiled="val">
    <dxo-label 
      [visible]="true" >
      <dxo-connector [visible]="true"></dxo-connector>
    </dxo-label>
  </dxi-series>
  <dxo-export [enabled]="false"></dxo-export>
  <dxo-legend
    [margin]="0"
    horizontalAlignment="right"
    verticalAlignment="top"
  ></dxo-legend>
  <dxo-tooltip
    [enabled]="true"
  >
  </dxo-tooltip> 
</dx-pie-chart>
